import { defineComponent as _defineComponent } from 'vue';
import CategoryTagsGraphql from '~/components/Molecules/CategoryTagsGraphql.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockCategoryTagsGraphql',
  props: {
    category: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var title = computed(function () {
      return props.category.title || translate('utils.relatedInCategory');
    });
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var listOfTags = computed(function () {
      var _props$category, _props$category$tagsC;
      return ((_props$category = props.category) === null || _props$category === void 0 ? void 0 : (_props$category$tagsC = _props$category.tagsCollection) === null || _props$category$tagsC === void 0 ? void 0 : _props$category$tagsC.items) || [];
    });
    return {
      __sfc: true,
      props: props,
      title: title,
      translate: translate,
      listOfTags: listOfTags,
      CategoryTagsGraphql: CategoryTagsGraphql
    };
  }
});